import { createContext } from 'react';

const SystemSettingsContext = createContext();

export default SystemSettingsContext;
